import request from '../servises/request'

export function getProxyPaidList(params = {}) {
  const queryString = new URLSearchParams(params).toString()
  const url = queryString ? `/proxy-paid?${queryString}` : '/proxy-paid'

  return request({
    url: url,
    method: 'GET'
  })
}

export function getPaidProxies() {
  return request({
    url: '/proxy/paid',
    method: 'GET'
  })
}

export function getProxyPaid(id) {
  return request({
    url: `/proxy-paid/${id}`,
    method: 'GET'
  })
}

export function createProxyPaid(data) {
  return request({
    url: '/proxy-paid',
    method: 'POST',
    data: data
  })
}

export function updateProxyPaid(id, data) {
  return request({
    url: `/proxy-paid/${id}`,
    method: 'PUT',
    data: data
  })
}

export function deleteProxyPaid(id) {
  return request({
    url: `/proxy-paid/${id}`,
    method: 'DELETE'
  })
}
